import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import $ from "jquery";

export default class FormPersonaContactoHermana extends Component {
  constructor(props) {
    super(props);
    this.DatosContactoPut = this.DatosContactoPut.bind(this);
  }

  // Función que hace un put a los datos de contacto de la hermana
  DatosContactoPut(event) {
    event.preventDefault();
    let myform = document.getElementById("MyForm");
    let form = new FormData(myform);
    let $this = $(this);

    let settings = {
      url: process.env.REACT_APP_API_URL + "/hermanas/" + $this[0].props.DatosMonja.sister.id + "/contacto",
      method: "PUT",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
      processData: false,
      mimeType: "multipart/form-data",
      contentType: false,
      data: form,
    };

    // Si es correcta hace actualiza el estado del componente hermana detalle
    $.ajax(settings)
      .done(function (response) {
        $this[0].props.setAlert("", "Se han editado los datos correctamente", "success");
        response = JSON.parse(response);
        $this[0].props.setDatosHermana(response);
      })
      .fail($this[0].props.ErrorHandling);
  }

  render() {
    return (
      <Form className=" p-4" onSubmit={this.DatosContactoPut} autoComplete="off" id="MyForm">
        <Form.Group>
          <Form.Row>
            <small className="mb-3">
              Los campos con un <b>*</b> deben de ser rellenados.
            </small>
          </Form.Row>
          <Form.Label>Nombre *</Form.Label>
          <Form.Control required type="text" name="contactName" maxLength="45" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.contactName} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Apellidos *</Form.Label>
          <Form.Control required type="text" name="contactSurname" maxLength="100" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.contactSurname} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Parentesco *</Form.Label>
          <Form.Control required type="text" name="contactRelationship" maxLength="100" autoComplete="nope" defaultValue={this.props.DatosMonja.sister.contactRelationship} />
        </Form.Group>
        <Form.Group>
          <Form.Label>País *</Form.Label>
          <Form.Control required maxLength="35" autoComplete="nope" type="text" name="contactCountry" defaultValue={this.props.DatosMonja.sister.contactCountry} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Provincia *</Form.Label>
          <Form.Control required maxLength="45" autoComplete="nope" type="text" name="contactProvince" defaultValue={this.props.DatosMonja.sister.contactProvince} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Dirección *</Form.Label>
          <Form.Control required maxLength="120" autoComplete="nope" type="text" name="contactAddress" defaultValue={this.props.DatosMonja.sister.contactAddress} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Teléfono *</Form.Label>
          <Form.Control required maxLength="25" autoComplete="nope" type="tel" name="contactTelephone" defaultValue={this.props.DatosMonja.sister.contactTelephone} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Email *</Form.Label>
          <Form.Control required maxLength="320" autoComplete="nope" type="email" name="contactEmail" defaultValue={this.props.DatosMonja.sister.contactEmail} />
        </Form.Group>
        <Form.Group>
          <Button
            type="submit"
            variant="outline-success"
            className="btn btn-block mt-5"
            //onClick={this.props.handleButtonShow} TODO cuando se le da a guardar no se cierra el modal
            name="Persona de Contacto"
          >
            Guardar
          </Button>
        </Form.Group>
      </Form>
    );
  }
}
